import L from 'leaflet';
import { ClusteredMarkerLayer } from './ClusteredMarkersLayer';
import type { Filter, FilterLayerOptions } from './Layers.types';

interface FilterLayer {
    options: FilterLayerOptions;
}

class FilterLayer extends L.Layer {
    _layers: ClusteredMarkerLayer[];
    _id: string;
    _filter: Filter;

    constructor(id: string, layers: ClusteredMarkerLayer[], options: FilterLayerOptions) {
        super(options);

        this.options = options;

        this._id = id;

        this._layers = layers;

        this._filter = {
            filterFn: this.options.filterFn,
            order: this.options.order,
        };

        if (this.options.inverted) {
            this._layers.forEach((layer) => layer.addFilter(this._id, this._filter));
        }
    }

    onAdd(): this {
        this._layers.forEach((layer) => {
            if (this.options.inverted) {
                layer.removeFilter(this._id);
            } else {
                layer.addFilter(this._id, this._filter);
            }
        });

        return this;
    }

    onRemove(): this {
        this._layers.forEach((layer) => {
            if (this.options.inverted) {
                layer.addFilter(this._id, this._filter);
            } else {
                layer.removeFilter(this._id);
            }
        });

        return this;
    }
}

export { FilterLayer };
